import { useEffect, useState } from 'react';
import type { CreateUpgradeChargeRequest } from '@/shared/api';
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
  Textarea,
} from '@/shared/components';

interface Props {
  open: boolean;
  currency: string;
  pending: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (request: CreateUpgradeChargeRequest) => void;
}

export function UpgradeChargeDialog({ open, currency, pending, onOpenChange, onSubmit }: Props) {
  const [description, setDescription] = useState('Apartment-Upgrade');
  const [amount, setAmount] = useState('');
  useEffect(() => {
    if (!open) return;
    setDescription('Apartment-Upgrade');
    setAmount('');
  }, [open]);
  const grossAmount = Number(amount.replace(',', '.'));
  const valid =
    description.trim().length > 0 &&
    grossAmount > 0 &&
    Math.round(grossAmount * 100) / 100 === grossAmount;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showClose={!pending}>
        <DialogHeader>
          <DialogTitle>Aufpreis anfordern</DialogTitle>
          <DialogDescription>
            StayOn sendet dem Gast einen eigenen Zahlungslink. Der ursprüngliche Buchungspreis und
            bestehende Rechnungen bleiben unverändert.
          </DialogDescription>
        </DialogHeader>
        <DialogBody className="space-y-4">
          <div>
            <Label htmlFor="upgrade-description">Beschreibung</Label>
            <Textarea
              id="upgrade-description"
              maxLength={500}
              value={description}
              onChange={(event) => setDescription(event.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="upgrade-amount">Bruttobetrag in {currency}</Label>
            <Input
              id="upgrade-amount"
              inputMode="decimal"
              placeholder="0,00"
              value={amount}
              onChange={(event) => setAmount(event.target.value)}
            />
            <p className="text-ink-faint mt-1.5 text-xs">
              Es gilt die beim Anlegen festgeschriebene Beherbergungssteuer.
            </p>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" disabled={pending} onClick={() => onOpenChange(false)}>
            Abbrechen
          </Button>
          <Button
            variant="brand"
            loading={pending}
            disabled={!valid}
            onClick={() =>
              onSubmit({
                upgradeChargeId: crypto.randomUUID(),
                description: description.trim(),
                grossAmount,
                currency,
                bookingReassignmentOperationId: null,
              })
            }
          >
            Zahlungslink senden
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
